import { render, staticRenderFns } from "./WidgetEditorDemoModal.vue?vue&type=template&id=35fd700a&"
import script from "./WidgetEditorDemoModal.vue?vue&type=script&lang=js&"
export * from "./WidgetEditorDemoModal.vue?vue&type=script&lang=js&"
import style0 from "./WidgetEditorDemoModal.vue?vue&type=style&index=0&id=35fd700a&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports